import {
  RadioGroup,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";
import useStyles from "../../../style/js-style/containers/users/user-profile/UserProfileStyle";
import i18next from "i18next";
import React, { useContext, useEffect, useState, useCallback } from "react";
import "react-phone-input-2/lib/style.css";
import { Context } from "../../../states/Store";
import EAIcon from "../../../components/common/EAIcon";
import { EVENT_CHECK_INDETERMINED, getPrivilegeAscendants, PrivilegeEnum, RoleBasedAccessControlContext, TIERS_EVENT_MANAGEMENT } from "services/common/RolesUtils";
import { isEmpty } from "lodash";
import _ from "lodash";
import {
  isEventPrivilege,
  isEventTaskPrivilege,
  DOSSIER_EVENT_MANAGEMENT,
  DOCUMENT_EVENT_MANAGEMENT,
  EVENT_TASKS,
} from "services/common/RolesUtils";
import EventPrivilegeBlock from "containers/administration/roles/privileges/common/EventPrivilegeBlock";
import RoleCheckBox from "containers/administration/roles/privileges/common/RoleCheckBox";
import {ERROR, Operator, SUCCESS} from "services/common/Constants";
import EAButton from "components/common/EAButton";
import { getAllUserEventSubscriptions, updateUserEventSubscriptions } from "services/edge/EventsService";
import { hasOption } from "services/common/Utils";
import { useAuth } from "@ea-webapp/auth";
import EAColorIcon from '../../../components/common/EAColorIcon';
import { getDataHubSources } from "services/common/DataHubUtils";

function UserNotifications({accountAttributesAndIndicators}) {
  const { classes } = useStyles();
  const [state, dispatch] = useContext(Context);
  const { isGlobalAdmin } = React.useContext(RoleBasedAccessControlContext);
  const { authState } = useAuth();

  const [grantableSubscriptions, setGrantableSubscriptions] = useState();
  const [grantableTasksSubscriptions, setGrantableTasksSubscriptions] = useState();
  const [userEventSubscriptions, setUserEventSubscriptions] = useState([]);
  const [selectedEventFrequency, setSelectedEventFrequency] = useState("INSTANT");
  const [userEventTasksSubscriptions, setUserEventTasksSubscriptions] = useState([]);
  const [selectedEventTasksFrequency, setSelectedEventTasksFrequency] = useState("INSTANT");
  const [shownTasks, setShownTasks] = useState([]);

     

      const {thirdpartyAttributes, dossierAttributes, 
    thirdpartyCalculatedAttributes, dossierCalculatedAttributes,
  thirdpartyIndicators, dossierIndicators} = accountAttributesAndIndicators;

  // This gives us the list of PRIVILEGE_EVENT that are grantable to the user via its roles if not a superadmin
  useEffect(() => {
    if (!isEmpty(state.roles)) {
      const eventGrantablePrivileges = state.roles.reduce(
        (accumulator, role) => {
          role.flatPrivileges?.forEach(
            (privilege) =>
              isEventPrivilege(privilege.name) &&
              accumulator.add(privilege)
          );
          return accumulator;
        },
        new Set()
      );

      const eventGrantableTasks = state.roles.reduce(
        (accumulator, role) => {
          role.flatPrivileges?.forEach(
            (privilege) =>
              isEventTaskPrivilege(privilege.name) &&
              accumulator.add(privilege)
          );
          return accumulator;
        },
        new Set()
      );
      setGrantableSubscriptions([...eventGrantablePrivileges]);
      setGrantableTasksSubscriptions([...eventGrantableTasks]);
    }
  }, [state.roles]);

  const isEventTaskActive = useCallback((privilege) => {
    return userEventTasksSubscriptions?.map(privilege => privilege.name).includes(privilege.name);
  }, [userEventTasksSubscriptions]);

  const toggleEventTask = (privilege) => {
    setUserEventTasksSubscriptions((prev) => {
      prev = prev?.map(p => p.name).includes(privilege.name)
        ? [...prev.filter((x) => x.name !== privilege.name)]
        : [...prev, privilege];
      return prev;
    });
  }

  // All criteria available for properties for a given privilege are listed in this list :
  const [listAllPropertiesCriteria, setListAllPropertiesCriteria] = useState([]);
  
  useEffect(() => {
    // Initialization of all criteria available for properties 
    const initialList = [];

    // For Indicators
    let thirdpartyIndicatorsAllPropertiesCriteria = {}
    thirdpartyIndicators?.forEach(indicator => {
      thirdpartyIndicatorsAllPropertiesCriteria[indicator?.value] = indicator.options.map(optionsBranche => {
          return {operator: Operator.EQUAL, value: optionsBranche?.value}
        });
      })

    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_INDICATOR_UPDATED,
      propertiesCriteria: thirdpartyIndicatorsAllPropertiesCriteria
    })

    let dossierIndicatorsAllPropertiesCriteria = {}
    dossierIndicators?.forEach(indicator => {
      dossierIndicatorsAllPropertiesCriteria[indicator?.value] = indicator.options.map(optionsBranche => {
          return {operator: Operator.EQUAL, value: optionsBranche?.value}
        });
      })

    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_INDICATOR_UPDATED,
      propertiesCriteria: dossierIndicatorsAllPropertiesCriteria
    })

    // For Calculated attributes
    let thirdpartyCalculatedAttributesAllPropertiesCriteria = {}
    thirdpartyCalculatedAttributes?.forEach(calculatedAttribute => {
      thirdpartyCalculatedAttributesAllPropertiesCriteria[calculatedAttribute?.value] = calculatedAttribute.options.map(optionsBranche => {
        return {operator: Operator.EQUAL, value: optionsBranche?.value}
      });
    })

    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_CALCULATED_ATTRIBUTE_UPDATED,
      propertiesCriteria: thirdpartyCalculatedAttributesAllPropertiesCriteria
    })

    let dossierCalculatedAttributesAllPropertiesCriteria = {}
    dossierCalculatedAttributes?.forEach(calculatedAttribute => {
      dossierCalculatedAttributesAllPropertiesCriteria[calculatedAttribute?.value] = calculatedAttribute.options.map(optionsBranche => {
        return {operator: Operator.EQUAL, value: optionsBranche?.value}
      });
    })

    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_CALCULATED_ATTRIBUTE_UPDATED,
      propertiesCriteria: dossierCalculatedAttributesAllPropertiesCriteria
    })
  
    // For Attributes
    let thirdpartyAttributesAllPropertiesCriteria = {}
    thirdpartyAttributes?.forEach(attribute => {
      thirdpartyAttributesAllPropertiesCriteria[attribute?.id] = attribute.options ? attribute.options?.map(option => {
        return {operator: Operator.EQUAL, value: option?.value}
      }) : [];
    })
    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_ATTRIBUTE_UPDATED,
      propertiesCriteria: thirdpartyAttributesAllPropertiesCriteria
    })

    let dossierAttributesAllPropertiesCriteria = {}
    dossierAttributes?.forEach(attribute => {
      dossierAttributesAllPropertiesCriteria[attribute?.id] = attribute.options ? attribute.options?.map(option => {
        return {operator: Operator.EQUAL, value: option?.value}
      }) : [];
    })
    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_ATTRIBUTE_UPDATED,
      propertiesCriteria: dossierAttributesAllPropertiesCriteria
    })

    //For dataHub Sources
    let dataHubSourcesPropertiesCriteria = {}
    getDataHubSources().forEach(source => {
      dataHubSourcesPropertiesCriteria[source?.sourceId] = [];
    })
    initialList.push({
      privilege: PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_DATA_HUB_UPDATED,
      propertiesCriteria: dataHubSourcesPropertiesCriteria
    })

    setListAllPropertiesCriteria(initialList);

  }, [dossierAttributes, dossierCalculatedAttributes, dossierIndicators, thirdpartyAttributes, thirdpartyCalculatedAttributes, thirdpartyIndicators])

  const hasPrivilegeOnProperty = useCallback((privilege, propertyId, criteria) => {
    if(isGlobalAdmin) return true;

    if(grantableSubscriptions?.map(priv => priv.name)?.includes(privilege.name + '_ALL')) {
      return true;
    }
    if(grantableSubscriptions?.map(priv => priv.name)?.includes(privilege.name)) {
      const grantablePrivilege = grantableSubscriptions?.find(priv => priv.name === privilege.name);
      if(!grantablePrivilege) return false;
        if(criteria && criteria.length > 0) {
          //if criteria is given and criteria != [], we evaluate if all criteria is grantable 
          return Object.keys(grantablePrivilege?.propertiesCriteria)?.includes(propertyId.toString()) &&
          criteria.every(item => {
            // criterion is grantable if present in grantablePrivilege's criteria, 
            // or grantablePrivilege's criteria for this property are empty
            return grantablePrivilege?.propertiesCriteria[propertyId]?.length === 0 ||
            grantablePrivilege?.propertiesCriteria[propertyId]?.some(criterion => criterion.operator === item.operator &&
              criterion.value === item.value
            );
          })
        } else {
          return Object.keys(grantablePrivilege?.propertiesCriteria)?.includes(propertyId.toString());
        }
    }
    return false;
  }, [grantableSubscriptions, isGlobalAdmin]);
  

  const getAllGrantablePropertiesCriteria = useCallback((privilege) => {
    // get all existing propertiesCriteria for this privilege : 
   const propertiesCriteria = listAllPropertiesCriteria?.find(item => item.privilege?.name === privilege.name)?.propertiesCriteria || {};
   // get all grantablePropertiesCriteria to select for this privilege
   const grantablepropertiesCriteria = {};
   for (const [id, criteria] of Object.entries(propertiesCriteria)) {
     const criteriaGrantable = [];
     criteria?.forEach(criterion => {
       if(hasPrivilegeOnProperty(privilege, id, [criterion])) {
         criteriaGrantable.push(criterion)
       }
     })
     const isPropertyWithNoCriteria = !propertiesCriteria[id] || propertiesCriteria[id].length === 0;
     if(criteriaGrantable.length > 0 || 
      (isPropertyWithNoCriteria && hasPrivilegeOnProperty(privilege, id, null)) ) {
      grantablepropertiesCriteria[id] = criteriaGrantable;
     }
   }
   return grantablepropertiesCriteria;
 }, [hasPrivilegeOnProperty, listAllPropertiesCriteria])

//for specific events privileges with properties, if global all privilege est present, selected all properties
const determinePropertiesThatMustBeSelected = useCallback(privileges => {
  const privilegesNames = privileges.map(privilege => privilege.name);
  return privileges.map(privilege => {
    const grantablePropertiesCriteria = getAllGrantablePropertiesCriteria(privilege) ;
    //get current propertiesCriteria
    let allPropertiesCriteria = privilege.propertiesCriteria || {};
    switch(privilege.name) {
      case PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_ATTRIBUTE_UPDATED.name:
        thirdpartyAttributes.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_ATTRIBUTE_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.id] = grantablePropertiesCriteria[att.id] || [];
          } else if(allPropertiesCriteria[att.id]?.length === 0 && grantablePropertiesCriteria[att.id]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.id] = grantablePropertiesCriteria[att.id] || [];
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
        
      case PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_CALCULATED_ATTRIBUTE_UPDATED.name:
        thirdpartyCalculatedAttributes.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_CALCULATED_ATTRIBUTE_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || [];
          } else if(allPropertiesCriteria[att.value]?.length === 0 && grantablePropertiesCriteria[att.value]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || []
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
      case PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_INDICATOR_UPDATED.name:
        thirdpartyIndicators.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_THIRD_PARTY_INDICATOR_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || [];
          } else if(allPropertiesCriteria[att.value]?.length === 0 && grantablePropertiesCriteria[att.value]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || []
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
      case PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_ATTRIBUTE_UPDATED.name:
        dossierAttributes.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_ATTRIBUTE_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.id] = grantablePropertiesCriteria[att.id] || [];
          } else if(allPropertiesCriteria[att.id]?.length === 0 && grantablePropertiesCriteria[att.id]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.id] = grantablePropertiesCriteria[att.id] || [];
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
      case PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_CALCULATED_ATTRIBUTE_UPDATED.name:
        dossierCalculatedAttributes.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_CALCULATED_ATTRIBUTE_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || [];
          } else if(allPropertiesCriteria[att.value]?.length === 0 && grantablePropertiesCriteria[att.value]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || []
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
      case PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_INDICATOR_UPDATED.name:
        dossierIndicators.forEach(att => {
          if(privilegesNames.includes(PrivilegeEnum.PRIVILEGE_EVENT_DOSSIER_INDICATOR_UPDATED_ALL.name)) {
            //when _ALL property privilege is present, we selected all properties and all criteria
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || [];
          } else if(allPropertiesCriteria[att.value]?.length === 0 && grantablePropertiesCriteria[att.value]?.length > 0){
            //if privilege is present but with criteria empty and grantable criteria, we assume all criteria should be toggle on
            allPropertiesCriteria[att.value] = grantablePropertiesCriteria[att.value] || []
          }
        })
        return {
          ...privilege, 
          propertiesCriteria: allPropertiesCriteria
        }
      default:
        return privilege;
    }
  })
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [thirdpartyCalculatedAttributes, thirdpartyIndicators, thirdpartyAttributes, dossierAttributes, dossierIndicators, dossierCalculatedAttributes]);

  useEffect(() => {
    const shownTasks = EVENT_TASKS.filter(task => isGlobalAdmin || grantableTasksSubscriptions?.map(priv => priv.name)?.includes(task.name));
    setShownTasks(
      shownTasks.map(task => ({
        name: i18next.t(`privileges.${task?.name}`),
        action: () => toggleEventTask(task),
        isActive: isEventTaskActive(task),
        isGrantable: isGlobalAdmin,
        variant: "topItemLight" //TODO: Change with task variant for css
      }))
    );
  }, [isGlobalAdmin, grantableTasksSubscriptions, isEventTaskActive])


  const fetchUserNotifications = useCallback( async () => {
        try {
          const res = await getAllUserEventSubscriptions(state.account.id);
          if(res.content) {
            const eventsSubs = res.content.filter(x => !x.eventType.includes("TASK"));
            setUserEventSubscriptions(determinePropertiesThatMustBeSelected(eventsSubs?.map(x => {
              return {
                name:`PRIVILEGE_EVENT_${x.eventType}`, 
                propertiesCriteria: x.propertiesCriteria, 
              }
            })));
            setSelectedEventFrequency(eventsSubs?.[0]?.frequency || "INSTANT");

            const tasksSubs = res.content.filter(x => x.eventType.includes("TASK"));
            setUserEventTasksSubscriptions(tasksSubs?.map(x => {
              return {
                name:`PRIVILEGE_EVENT_${x.eventType}`
              }
            }));
            setSelectedEventTasksFrequency(tasksSubs?.[0]?.frequency || "INSTANT");
          }
        } catch (e) {
          dispatch({
            type: "ALERT",
            alert: {
              type: ERROR,
              msg: e?.message?.error?.[0]?.message || "INTERNAL_ERROR"
            },
          });
        }
      }, [determinePropertiesThatMustBeSelected, dispatch, state.account.id]);

  useEffect(() => {
    if (authState.user?.id && state.account?.id && thirdpartyAttributes && thirdpartyCalculatedAttributes && thirdpartyIndicators && dossierAttributes &&
      dossierCalculatedAttributes && dossierIndicators
    ) {
      fetchUserNotifications();
    }
  }, [authState.user?.id, state.account?.id, dispatch, fetchUserNotifications, 
    thirdpartyAttributes, thirdpartyCalculatedAttributes, thirdpartyIndicators, 
    dossierAttributes, dossierCalculatedAttributes, dossierIndicators]);


  // checkbox is shown active if the privilege is active or is a parent with every grantable child active
  const isSubscriptionActive = (privilege) => {
    if(isEmpty(privilege.childPrivileges)) {
      return userEventSubscriptions?.map(priv => priv.name)?.includes(privilege.name)
    } else {
      //if all children is check, return true
      const eventChilds = privilege.childPrivileges.filter(child => isEventPrivilege(child.name))
      if(eventChilds.every(child => isSubscriptionActive(child) === true && isSubscriptionShown(child))) {
        return true;
      // if one or more children is check, return INDETERMINED
      } else if(eventChilds.some(child => isSubscriptionActive(child) !== false && isSubscriptionShown(child))) {
        return EVENT_CHECK_INDETERMINED;
      }
      // retrun false in all other case
      return false;
    }
  };

  const isSubscriptionActiveGroupped = (...privileges) => {
    return privileges.every((p) => toBoolean(isSubscriptionActive(p)));
  };

  const isSubscriptionShown = (privilege) => {
    if(isEmpty(privilege.childPrivileges)) {
      return isGlobalAdmin || grantableSubscriptions?.map(priv => priv.name)?.includes(privilege.name) || grantableSubscriptions?.map(priv => priv.name)?.includes(privilege.name + '_ALL')
      || [...getPrivilegeAscendants(privilege)].some(asc => grantableSubscriptions?.map(privilege => privilege.name).includes(asc));;
    } else {
      //if the privilege is granted, return true, else find if there one child with privilege
      return grantableSubscriptions?.map(priv => priv.name)?.includes(privilege.name) || privilege.childPrivileges.filter(child => isEventPrivilege(child.name)).some(child => isSubscriptionShown(child))
    }
  };

  const isSubscriptionShownGroupped = (...privileges) => {
    return privileges.every((p) => isSubscriptionShown(p));
  };

  const toBoolean = (item) => {
    return item === EVENT_CHECK_INDETERMINED ? false : item;
  }

  // Function to Remove or Add an EVENT PRIVILEGE SUBSCRIPTION
  const togglePrivilegeSubscription = (...privileges) => {
    privileges?.forEach(privilege => {
      if(!isEmpty(privilege.childPrivileges)) {
        privilege.childPrivileges.forEach(child => isSubscriptionShown(child)  && (toBoolean(isSubscriptionActive(child)) === toBoolean(isSubscriptionActive(privilege))) 
        && togglePrivilegeSubscription(child));
      } else {
        setUserEventSubscriptions((prev) => {
          prev = prev?.map(privi => privi.name)?.includes(privilege.name)
            ? [...prev.filter((x) => x.name !== privilege.name)]
            : [...prev, privilege];
          return prev;
        });
      }
    })
  };

  const selectAll = (privilege) => {
            if(!isEmpty(privilege.childPrivileges)) {
        privilege.childPrivileges.forEach(child => selectAll(child));
      } else {
        // get all grantablePropertiesCriteria to select for this privilege
      const grantablepropertiesCriteria = getAllGrantablePropertiesCriteria(privilege);

        setUserEventSubscriptions((prev) => {
          if(prev.find(oldpriv => oldpriv.name === privilege.name)) {
            return prev.map(oldprivilege => {
              if(oldprivilege.name === privilege.name) {
                return {
                  ...oldprivilege,
                  // selected of all properties grantabled
                  propertiesCriteria: grantablepropertiesCriteria
                }
              } else {
                return oldprivilege;
              }
            })
          }
          //if events not already selected, we add it
          return [...prev, {
            ...privilege, 
            // selected of all properties grantabled
            propertiesCriteria: grantablepropertiesCriteria
          }]
        });
      }
  }

  const unselectAll = (...privileges) => {
    privileges?.forEach(privilege => {
      if(!isEmpty(privilege.childPrivileges)) {
        privilege.childPrivileges.forEach(child => unselectAll(child));
      } else {
        setUserEventSubscriptions((prev) => {
          return [...prev.filter((x) => x.name !== privilege.name)]
        });
      }
    })
  }

  /* Functions for manage subscriptions for specific properties events */



  const hasCurrentAnyOfSpecificPropertySubscription = useCallback((propertyId, criterion, locPrivilege) => {
    /* if (!_.isEmpty(userEventSubscriptions)) {
      return locPrivileges.some(priv => userEventSubscriptions.find(privilege => privilege.name === priv.name)?.properties?.includes(propertyId));
    }
    return false; */

    if (!_.isEmpty(userEventSubscriptions) && locPrivilege) {
      if(criterion) {
        const currentPropertiesCriteria = userEventSubscriptions.find(priv => locPrivilege.name === priv.name)?.propertiesCriteria;
        if(!currentPropertiesCriteria || !currentPropertiesCriteria[propertyId]) {
          return false;
        }
        if(currentPropertiesCriteria[propertyId]?.length === 0) {
          //if propertyId is present but array empty, no criterion available or all crieteria granted
          return true;
        }
        return currentPropertiesCriteria[propertyId].some(currentCriterion => {
          return currentCriterion.operator === criterion.operator && currentCriterion.value === criterion.value
        }); 
      } else {
        //case where criterion == null
        const allPropertiesCriteria = userEventSubscriptions.find(priv => locPrivilege.name === priv.name)?.propertiesCriteria;
        const propertyCriteria = allPropertiesCriteria ? allPropertiesCriteria[propertyId] : null

        const hasPropertyIdKey = allPropertiesCriteria ? Object.keys(allPropertiesCriteria)?.includes(propertyId.toString()) : false

        if(!propertyCriteria && hasPropertyIdKey) {
          //no criteria available for this property, is propertyId is present in keys, the property is toogled on
          return true;
        } else if(!propertyCriteria) {
          //no criteria selected or available
          return false;
        } else {
          const grantablepropertiesCriteria = getAllGrantablePropertiesCriteria(locPrivilege)
          if(grantablepropertiesCriteria && grantablepropertiesCriteria[propertyId]) {
            const grantableCriteria = grantablepropertiesCriteria[propertyId]
            if(propertyCriteria.length === grantableCriteria?.length) {
              // all criteria are selected
              return true;
            } else {
              //only partial criteria are selected
              return EVENT_CHECK_INDETERMINED;
            }
          } else {
            //without grantablepropertiesCriteria but with propertyId in propertiesCriteria, this propertyId should be toogle on
            return true;
          }
        }
      }
    }
    return false;
  }, [getAllGrantablePropertiesCriteria, userEventSubscriptions])

  const hasCurrentAllOfSpecificPropertySubscription = useCallback((locPrivilege) => {
    const grantablePropertiesCriteria = getAllGrantablePropertiesCriteria(locPrivilege) ;
    const propertiesIds = Object.keys(grantablePropertiesCriteria) || [];

    if (!_.isEmpty(userEventSubscriptions) && userEventSubscriptions.map(privilege => privilege.name)?.includes(locPrivilege.name)) {
      //If all properties is check, return true;
      if(propertiesIds.every(id => hasCurrentAnyOfSpecificPropertySubscription(id, null, locPrivilege) === true)){
        return true;
      // If one property or more are check, return INDETERMINED
      }  else if(propertiesIds.some(id => {
        const hasCurrentProperty = hasCurrentAnyOfSpecificPropertySubscription(id, null, locPrivilege);
        return hasCurrentProperty === EVENT_CHECK_INDETERMINED || hasCurrentProperty === true;
      })) {
        return EVENT_CHECK_INDETERMINED
      }
      //return false in all other case
    }
    return false;
  }, [getAllGrantablePropertiesCriteria, hasCurrentAnyOfSpecificPropertySubscription, userEventSubscriptions])

  const toggleAllPropertiesOfEventType = useCallback((privilege) => {
    const propertiesWithAllCriteria = listAllPropertiesCriteria?.find(item => item.privilege?.name === privilege.name)?.propertiesCriteria;
    // get all grantablePropertiesCriteria to select for this privilege
    const grantablepropertiesCriteria = getAllGrantablePropertiesCriteria(privilege);
    setUserEventSubscriptions(prev => {
        const grantedPrivilege = prev.find(priv => priv.name === privilege.name);
        if (grantedPrivilege) {
          if (!hasCurrentAllOfSpecificPropertySubscription(privilege)) {
            let propertiesCriteria = {};
            Object.keys(propertiesWithAllCriteria).forEach(element => {
              propertiesCriteria[element] = propertiesWithAllCriteria[element] || [];
            });
            grantedPrivilege.propertiesCriteria = propertiesCriteria;
          } else {
            // when all properties is toggle off, remove "_ALL" privilege property if present
            prev = prev.filter(pri => pri.name !== (privilege.name + "_ALL"));

            return Array.from(prev.filter(pr => pr.name !== privilege.name));
          }
        } else {
          prev.push({ name: privilege.name, propertiesCriteria: grantablepropertiesCriteria });
        }
        return Array.from(prev);
    })
  }, [getAllGrantablePropertiesCriteria, hasCurrentAllOfSpecificPropertySubscription, listAllPropertiesCriteria]);

  const togglePropertySubscription = useCallback((propertyId, propertyCriterion, privilegeAllProperties, ...privileges) => {
    setUserEventSubscriptions(prev => {
      privileges.forEach((privilege) => {
        const grantedPrivilege = prev.find(priv => priv.name === privilege.name);
        // get all grantablePropertiesCriteria to select for this privilege
        const grantablepropertiesCriteria = getAllGrantablePropertiesCriteria(privilege);
        if (grantedPrivilege) {
          //privilege for this specific propertyId is present
          const hasPropertyToogledOn = hasCurrentAnyOfSpecificPropertySubscription(propertyId, propertyCriterion, privilege);
          if (hasPropertyToogledOn === true) {
            // Property (and criterion) should be toggled off
            if(propertyCriterion && grantedPrivilege.propertiesCriteria[propertyId]?.length > 1) {
              grantedPrivilege.propertiesCriteria[propertyId] = grantedPrivilege.propertiesCriteria[propertyId]?.filter(criterion => 
                !(criterion.operator === propertyCriterion.operator && criterion.value === propertyCriterion.value))
            } else {
              delete grantedPrivilege.propertiesCriteria[propertyId]
              
              if(Object.keys(grantedPrivilege.propertiesCriteria)?.length === 0 ) {
                prev = prev.filter(pri => pri.name !== grantedPrivilege.name);
              }
            }
            // when one property is toggle off, remove "_ALL" privilege property if present
              prev = prev.filter(pri => pri.name !== privilegeAllProperties.name);
          } else {
            //Property (and criterion) should be - completely - toggled on
            grantedPrivilege.propertiesCriteria = grantedPrivilege.propertiesCriteria || {};
            grantedPrivilege.propertiesCriteria[propertyId] = grantedPrivilege.propertiesCriteria[propertyId] || [];
            if(propertyCriterion) {
              grantedPrivilege.propertiesCriteria[propertyId].push(propertyCriterion);
            } else {
              // when propertyCriterion == null, we try to toggle on/off all criteria of this propertyId
              grantedPrivilege.propertiesCriteria[propertyId] = grantablepropertiesCriteria[propertyId]
            } 
          }
        } else {
            // add privilege for this specific propertyId
            let propertiesCriteria = {};
            propertiesCriteria[propertyId] = [];
            if(propertyCriterion) {
              //add privilege with this property
              propertiesCriteria[propertyId] = [propertyCriterion]
            } else if(grantablepropertiesCriteria[propertyId]?.length > 0) {
              //when propertyCriterion == null, we toggle on all criteria of this propertyId
              propertiesCriteria[propertyId] = grantablepropertiesCriteria[propertyId]
            }   
            prev.push({ name: privilege.name, propertiesCriteria: propertiesCriteria });
        }
      });
      return Array.from(prev);
    })
  }, [getAllGrantablePropertiesCriteria, hasCurrentAnyOfSpecificPropertySubscription]); 

  const handlEventsFrequency = (event, value) => {
    setSelectedEventFrequency(value)
  }

  const handlEventsTasksFrequency = (event, value) => {
    setSelectedEventTasksFrequency(value)
  }

  const hasOptionSubscription = useCallback((option) => {
    return hasOption(state?.accounts, state?.account?.id, option) 
  }, [state?.account?.id, state?.accounts])

  //Save events and tasks subscriptions :
  const saveEventSubscriptions = async () => {
    const userEventSubscriptionsDto = userEventSubscriptions?.map(sub => (
      {
        eventType: sub?.name?.substring(16), 
        propertiesCriteria: sub?.propertiesCriteria,
        frequency: selectedEventFrequency
      })) || [];
    const userEventTasksSubscriptionsDto = userEventTasksSubscriptions?.map(sub => (
      {
        eventType: sub?.name?.substring(16), 
        propertiesCriteria: sub?.propertiesCriteria,
        frequency: selectedEventTasksFrequency
      })) || [];
    try {
      await updateUserEventSubscriptions(state.account.id, [...userEventSubscriptionsDto, ...userEventTasksSubscriptionsDto])
      dispatch({
        type: "ALERT",
        alert: { type: SUCCESS, msg: i18next.t("userProfile.saveSuccess") },
      });
    } catch (error) {
      dispatch({
        type: "ALERT",
        alert: { type: ERROR, msg: error?.message?.messages?.error?.[0]?.code || "INTERNAL_ERROR" },
      });
    }

  }

  return (
    <>
      {/* Save */}
      <EAButton
        onClick={saveEventSubscriptions}
        content={<EAIcon icon={"save"} />}
        className={classes.saveButton}
      />

      {/* Tasks */}
      <div className={classes.myTaskWrapper}>
       <div className={classes.myTaskMainContentWrapper}>
        {/* Title */}
        <div className={classes.myTaskMainTitle}>
          <EAIcon icon="profil/myTasks" className={classes.myTaskTitleIcon} />
          <span>{i18next.t("userProfile.myTasks")}</span>
        </div>

        {/* Content */}
        <div className={classes.myTaskMainContent}>
          {shownTasks.map((item, index) => (
            <RoleCheckBox item={item} key={index} variant="profile"/>
          ))}
        </div>
       </div>

       {/* Task Frequency */}
       <div className={classes.myTaskFrequency}>
         <div className={classes.myTaskFrequencyTitle}>
           {i18next.t(`userProfile.frequency.emailFrequency`)}
         </div>
          <FormControl>
            <RadioGroup row value={selectedEventTasksFrequency} onChange={handlEventsTasksFrequency}>
              <FormControlLabel
                value="INSTANT"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    icon={<EAColorIcon icon={"input/radio-unchecked"} />}
                    checkedIcon={<EAColorIcon icon={"input/radio-checked"} />}
                  />
                }
                label={i18next.t(`userProfile.frequency.immediate`)}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>

      {/* Events */}
      <div className={classes.eventWrapper}>
        <div className={classes.eventMainContentWrapper}>
          {/* Title */}
          <div className={classes.eventMainTitle}>
            <EAColorIcon icon="profil/events" className={classes.eventTitleIcon} />
            <span>{i18next.t(`userProfile.events`)}</span>
          </div>

          {/* Content */}
          <div className={classes.eventMainContent}>
            {/* Tiers */}
            <EventPrivilegeBlock
              openDefault={true}
              data={TIERS_EVENT_MANAGEMENT(
                hasOptionSubscription,
                togglePrivilegeSubscription,
                isSubscriptionActive,
                isSubscriptionShown,
                isSubscriptionActiveGroupped,
                isSubscriptionShownGroupped,
                selectAll,
                unselectAll, 
                thirdpartyAttributes, 
                thirdpartyCalculatedAttributes, 
                thirdpartyIndicators, 
                togglePropertySubscription, 
                toggleAllPropertiesOfEventType, 
                hasCurrentAnyOfSpecificPropertySubscription, 
                hasCurrentAllOfSpecificPropertySubscription,
                hasPrivilegeOnProperty, 
                getDataHubSources()
              )}
              grantMode="hide"
              variant="profile"
            />
            {/*Dossier*/}
            <EventPrivilegeBlock
              openDefault={true}
              data={DOSSIER_EVENT_MANAGEMENT(
                togglePrivilegeSubscription,
                isSubscriptionActive,
                isSubscriptionShown,
                isSubscriptionActiveGroupped,
                isSubscriptionShownGroupped,
                selectAll,
                unselectAll,
                dossierAttributes, 
                dossierCalculatedAttributes, 
                dossierIndicators, 
                togglePropertySubscription, 
                toggleAllPropertiesOfEventType, 
                hasCurrentAnyOfSpecificPropertySubscription, 
                hasCurrentAllOfSpecificPropertySubscription,
                hasPrivilegeOnProperty, 
              )}
              grantMode="hide"
              variant="profile"
            />
            {/* Document */}
            <EventPrivilegeBlock
              openDefault={true}
              data={DOCUMENT_EVENT_MANAGEMENT(
                togglePrivilegeSubscription,
                isSubscriptionActive,
                isSubscriptionShown,
                isSubscriptionActiveGroupped,
                isSubscriptionShownGroupped,
                selectAll,
                unselectAll
              )}
              grantMode="hide"
              variant="profile"
            />
          </div>
        </div>

        {/* Event Frequency */}
        <div className={classes.eventFrequency}>
          <div className={classes.myTaskFrequencyTitle}>
            {i18next.t(`userProfile.frequency.emailFrequency`)}
          </div>
          <FormControl>
            <RadioGroup row value={selectedEventFrequency} onChange={handlEventsFrequency}>
              <FormControlLabel
                value="INSTANT"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    icon={<EAColorIcon icon={"input/radio-unchecked"} />}
                    checkedIcon={<EAColorIcon icon={"input/radio-checked"} />}
                  />
                }
                label={i18next.t(`userProfile.frequency.immediate`)}
              />
            </RadioGroup>
          </FormControl>
        </div>

      </div>
    </>
  );
}

export default UserNotifications;
